export const honorsAndAwards = [
  {
    id: 1,
    title: "Best Young Researcher Award",
    issuer: "UP-STAT American Stastical Association",
    issued: "Nov 2017",
    link: require("@/assets/awards/upSTAT.gif")
  },
  {
    id: 2,
    title: "Exhibitor @Imagine RIT",
    issuer: "Rochester Institute of Technology",
    issued: "May 2017",
    link: require("@/assets/awards/imagineRIT.png")
  },
  {
    id: 3,
    title: "Tiger Tank Semifinalist",
    issuer: "RIT Enterpreneur Conference",
    issued: "Oct 1 2016",
    link: require("@/assets/awards/tigertank.png")
  },
  {
    id: 4,
    title: "Best Poster",
    issuer: "Effective Access Technology Conference",
    issued: "Apr 2017",
    link: require("@/assets/awards/EAT.png")
  },
  {
    id: 5,
    title: "Best Research Paper Presentor",
    issuer: "National Technical Institute for the Deaf (NTID)",
    issued: "June 2018",
    link: require("@/assets/awards/NTID.png")
  },
  {
    id: 6,
    title:
      "Presented Paper on Differential aspects and performance Analysis of Time Difference on Cherry",
    issuer: "UP-STAT American Statistical Association",
    issued: "Apr 2017",
    link: require("@/assets/awards/upSTAT.gif")
  },
  {
    id: 7,
    title: "Best Paper on 3D face Recognition",
    issuer: "Techadroid VIT",
    issued: "May 2012",
    link: require("@/assets/awards/VIT.png")
  },
  {
    id: 8,
    title: "Distinction",
    issuer: "Australian Chemistry Olyampiad",
    issued: "2007",
    link: require("@/assets/awards/australianChemistryOlympiad.png")
  }
];
